/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as RichtextFacet from "../../../app/bsky/richtext/facet.defs.js";

const $nsid = "place.stream.richtext.facet";

export { $nsid };

/** Annotation of a sub-string within rich text in a livestream chat message. */
type Main = { $type?: "place.stream.richtext.facet";"index":RichtextFacet.ByteSlice;"features":(l.$Typed<RichtextFacet.Mention> | l.$Typed<RichtextFacet.Link> | l.Unknown$TypedObject)[] };

export type { Main };

/** Annotation of a sub-string within rich text in a livestream chat message. */
const main = /*#__PURE__*/ l.typedObject<Main>($nsid, "main", /*#__PURE__*/ l.object({"index":/*#__PURE__*/ l.ref<RichtextFacet.ByteSlice>((() => RichtextFacet.byteSlice) as any),"features":/*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<RichtextFacet.Mention>((() => RichtextFacet.mention) as any),/*#__PURE__*/ l.typedRef<RichtextFacet.Link>((() => RichtextFacet.link) as any)], false), )}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
